export default "__VITE_PUBLIC_ASSET__6652ddf7__"